import { LessonColorScheme } from '@onesource/schemas';

/**
 * Lesson / section color scheme palette (from Figma design).
 * Each scheme maps to a background color and a contrasting icon color so the
 * section icon stays legible on top of the background.
 */
export const LESSON_COLOR_SCHEME_MAP: Record<LessonColorScheme, { bgcolor: string; iconColor: string }> = {
  [LessonColorScheme.CORAL]: { bgcolor: 'rgba(255,114,98,0.78)', iconColor: '#FFE9DB' },
  [LessonColorScheme.GREEN]: { bgcolor: '#b7c6bb', iconColor: '#FFE9DB' },
  [LessonColorScheme.PEACH]: { bgcolor: '#ffe9db', iconColor: '#FF073B' },
  [LessonColorScheme.BLUE]: { bgcolor: '#b8daee', iconColor: '#1F5C7A' },
};

/**
 * Resolve a lesson/section color scheme to its colors, falling back to GREEN
 * when the value is missing or not a known scheme.
 */
export const getLessonColorScheme = (colorScheme?: LessonColorScheme | string | null) =>
  LESSON_COLOR_SCHEME_MAP[colorScheme as LessonColorScheme] ?? LESSON_COLOR_SCHEME_MAP[LessonColorScheme.GREEN];
